import { render, staticRenderFns } from "./CustomEmailLanding.vue?vue&type=template&id=6f5a2e79&scoped=true"
import script from "./CustomEmailLanding.vue?vue&type=script&lang=js"
export * from "./CustomEmailLanding.vue?vue&type=script&lang=js"
import style0 from "./CustomEmailLanding.vue?vue&type=style&index=0&id=6f5a2e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5a2e79",
  null
  
)

export default component.exports